import * as React from "react"

import deleteSoundFile from "../../../../../../api/soundfiles/delete"
import updateSoundFile from "../../../../../../api/soundfiles/update"
import { useAppDispatch } from "../../../../../../redux"
import { addSnackbar } from "../../../../../../redux/snackbars"
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  LoadingButton,
  TextField,
} from "@podcastsoundboard/ps-lib/ui"
import DeleteIcon from "@podcastsoundboard/ps-lib/ui/icons/Delete"

interface SoundFile {
  uuid: string
  name: string
}

interface EditSoundFileModalProps {
  open: boolean
  soundFile: SoundFile
  handleClose: () => void
  onUpdate?: () => void
}

const EditSoundFileModal: React.FC<EditSoundFileModalProps> = ({
  open,
  soundFile,
  handleClose,
  onUpdate,
}) => {
  const dispatch = useAppDispatch()

  const [submitting, setSubmitting] = React.useState(false)
  const [deleting, setDeleting] = React.useState(false)
  const [deleteAreYouSureOpen, setDeleteAreYouSureOpen] = React.useState(false)

  const [name, setName] = React.useState("")

  const deleteAction = () => {
    setDeleting(true)
    deleteSoundFile({ soundFileUuid: soundFile.uuid })
      .then(() => {
        setDeleting(false)
        dispatch(
          addSnackbar({
            text: "Deleted soundFile.",
          }),
        )
        onUpdate && onUpdate()
        setDeleteAreYouSureOpen(false)
      })
      .catch((err) => {
        console.error(err)
        setDeleting(false)
        setDeleteAreYouSureOpen(false)
        dispatch(
          addSnackbar({
            text: "Failed to delete sound file.",
          }),
        )
      })
  }

  const handleSubmit = (
    _event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    // event.preventDefault()

    setSubmitting(true)

    updateSoundFile({ soundFileUuid: soundFile.uuid, name })
      .then(() => {
        setSubmitting(false)
        dispatch(
          addSnackbar({
            id: "updatesoundFilesuccess",
            text: "Updated sound file.",
          }),
        )
        onUpdate && onUpdate()
        setName("")
      })
      .catch((err) => {
        console.error(err)
        setSubmitting(false)
        dispatch(
          addSnackbar({
            text: "Failed to update sound file.",
          }),
        )
      })
  }

  const receiveSoundFile = (soundFile: SoundFile) => {
    setName(soundFile.name)
  }

  React.useEffect(() => {
    soundFile && receiveSoundFile(soundFile)
  }, [soundFile])

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth="sm"
    >
      <Box
        display="flex"
        flexDirection="row"
        alignItems="flex-start"
        justifyContent="space-between"
        flexWrap="wrap"
      >
        <DialogTitle id="alert-dialog-title">Edit Sound File</DialogTitle>

        <IconButton
          onClick={() => setDeleteAreYouSureOpen(true)}
          className="my-2 mx-4"
          aria-label="back"
        >
          <DeleteIcon style={{ height: 30, width: 30 }} />
        </IconButton>

        <Dialog
          open={deleteAreYouSureOpen}
          onClose={() => setDeleteAreYouSureOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle id="alert-dialog-title">
            Are you sure you want to delete this sound file?
          </DialogTitle>
          <DialogActions>
            <LoadingButton
              loading={deleting}
              onClick={deleteAction}
              variant="contained"
            >
              Delete
            </LoadingButton>
            <LoadingButton onClick={() => setDeleteAreYouSureOpen(false)}>
              Cancel
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </Box>

      <DialogContent>
        <Box
          display="flex"
          flexDirection="row"
          alignItems="flex-start"
          flexWrap="wrap"
        >
          <Box display="flex" flexGrow={1}>
            <Box className="mt-2 mb-4" style={{ width: "100%" }}>
              <TextField
                name="name"
                required
                id="name"
                fullWidth
                value={name}
                label="Name"
                onChange={(e) => setName(e.target.value)}
              />
            </Box>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions>
        <LoadingButton
          disabled={!name}
          loading={submitting}
          onClick={handleSubmit}
          variant="contained"
        >
          Create
        </LoadingButton>
        <LoadingButton onClick={handleClose}>Cancel</LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
export default EditSoundFileModal
